import React, { useState, useEffect } from "react";
import api from "../../services/api";

const StickerPreview = ({ imageUrl }) => {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    if (!imageUrl) return;
    let objectUrl;
    const fetchSticker = async () => {
      const { data, headers } = await api.get(imageUrl, { responseType: "blob" });
      objectUrl = window.URL.createObjectURL(new Blob([data], { type: headers["content-type"] }));
      setSrc(objectUrl);
    };
    fetchSticker();
    return () => {
      if (objectUrl) window.URL.revokeObjectURL(objectUrl);
    };
  }, [imageUrl]);

  return (
    <img
      src={src || imageUrl}
      alt="sticker"
      className="w-32 h-32 object-contain"
    />
  );
};

export default StickerPreview;
